export const chartConfigs = {
  16: [
    {
      type: "column",
      title: "Forest Fire Occurrence in Nepal",
      plotOptions: {
        series: {
          dataSorting: {
            enabled: false,
          },
          color: "#FA4B42",
        },
      },
      series: {
        "Forest Fire": {
          2013: 1748,
          2014: 2061,
          2015: 424,
          2016: 5190,
          2017: 1545,
          2018: 1303,
          2019: 3219,
          2020: 1012,
          2021: 6537,
          2022: 1528,
          2023: 3195,
          2024: 5136,
        },
      },
    },

    // {
    //     type: "line",
    //     title: "Monthly Sales Data",
    //     titleAlign: "center",
    //     categories:[
    //         "2013",
    //         "2014",
    //         "2015",
    //         "2016",
    //         "2017",
    //         "2018",
    //         "2019",
    //         "2020",
    //         "2021",
    //         "2022",
    //         "2023",
    //         "2024"
    //     ],
    //     xAxisTitle: "years",
    //     yAxisTitle: "occurence",
    //     series: [
    //         {
    //             name: "Forest Fire",
    //             data: [1748, 2061, 424, 5190, 1545, 1303, 3219, 1012, 6537, 1528, 3195, 5136]
    //         },

    //     ]
    // }
  ],
  9: [
    {
      type: "column",
      title: "Earthquake Incidents (>5 mag)",
      chart: "",
      unit: "Count",
      plotOptions: {
        series: {
          tooltip: {
            pointFormat: "{point.name}: <b>{point.y:,.0f}</b>",
          },
          dataSorting: {
            enabled: false,
          },
          color: "#FA4B42",
        },
      },
      series: {
        count: {
          1971: 11,
          1972: 12,
          1973: 40,
          1974: 18,
          1975: 40,
          1976: 29,
          1977: 22,
          1978: 13,
          1979: 15,
          1980: 23,
          1981: 18,
          1982: 15,
          1983: 15,
          1984: 37,
          1985: 24,
          1986: 29,
          1987: 11,
          1988: 19,
          1989: 27,
          1990: 45,
          1991: 22,
          1992: 22,
          1993: 24,
          1994: 28,
          1995: 15,
          1996: 18,
          1997: 27,
          1998: 24,
          1999: 23,
          2000: 26,
          2001: 34,
          2002: 27,
          2003: 20,
          2004: 36,
          2005: 53,
          2006: 17,
          2007: 20,
          2008: 61,
          2009: 31,
          2010: 32,
          2011: 19,
          2012: 20,
          2013: 37,
          2014: 24,
          2015: 41,
          2016: 26,
          2017: 16,
          2018: 15,
          2019: 18,
          2020: 20,
          2021: 34,
          2022: 34,
          2023: 26,
          2024: 14,
        },
      },
    },
    {
      type: "pie",
      title: "Countrywise Earthquake Incidents within HKH (1971-2024)",
      chart: "",
      unit: "count",
      plotOptions: {
        series: {
          tooltip: {
            pointFormat: "{point.name}: <b>{point.y:,.0f}</b>",
          },
        },
      },
      series: {
        Count: {
          Afghanistan: 380,
          Bangladesh: 4,
          Bhutan: 12,
          China: 522,
          India: 113,
          Myanmar: 76,
          Nepal: 71,
          Pakistan: 189,
        },
      },
    },
  ],
  11: [
    {
      type: "column",
      title: "Operational Hydropower Plants in Bhutan",
      chart: "",
      unit: "capacity (mw)",
      plotOptions: {
        series: {
          tooltip: {
            pointFormat: "{point.name}: <b>{point.y:,.0f} mw</b>",
          },
          showInLegend: false,
        },
      },
      series: {
        Hydropowers: {
          Basochhu: 40,
          Chukha: 336,
          Dagachhu: 252,
          Kurichhu: 60,
          Mangdechhu: 720,
          Nikachhu: 118,
          Tala: 1020,
        },
      },
    },
    {
      type: "bar",
      title: "Hydropower Plants Under Construction in Bhutan",
      chart: "",
      unit: "count",
      yAxis: {
        title: {
          text: "",
        },
        labels: {
          overflow: "justify",
        },
        reversed: true,
        gridLineWidth: 0,
      },
      plotOptions: {
        series: {
          tooltip: {
            pointFormat: "{point.name}: <b>{point.y:,.0f} mw</b>",
          },
          showInLegend: false,
        },
      },
      series: {
        Hydropowers: {
          Jomori: 90,
          Kholongchu: 600,
          "Punatsangchhu-I": 1200,
          "Punatsangchhu-II": 1020,
          Wangchhu: 570,
        },
      },
    },
    {
      type: "bar",
      title: "Planned Hydropower Plants in Bhutan",
      chart: "",
      unit: "count",
      plotOptions: {
        series: {
          tooltip: {
            pointFormat: "{point.name}: <b>{point.y:,.0f} mw</b>",
          },
          showInLegend: false,
        },
      },
      series: {
        Hydropowers: {
          Amochhu: 540,
          Bunakha: 180,
          "Chamkharchhu-I": 770,
          Dorjilung: 1125,
          "Kuri Gongri": 2640,
          Sankosh: 2560,
        },
      },
    },
  ],
  12: [
    {
      type: "pie",
      title: "Mechanism of Lake breach",
      chart: "",
      unit: "count",
      plotOptions: {
        series: {
          tooltip: {
            pointFormat: "{point.name}: <b>{point.y:,.0f}</b>",
          },
        },
      },
      series: {
        Count: {
          "Permafrost thaw, Moraine failure": 1,
          "Permafrost thaw, subglacial channel": 1,
          "Dam piping": 5,
          "Dam seepage": 1,
          "Englacial tunnel": 2,
          "Ice core thawing": 10,
          "Moraine collapse": 16,
          "Moraine collapse, permafrost thaw": 1,
          Overflow: 1,
          Overtopping: 1,
          "Subglacial tunnel": 142,
          "Subglacial tunnel, overtopping": 1,
          "Supraglacial lake drainage": 5,
          Unknown: 549,
        },
      },
    },
    {
      type: "column",
      title: "Types of Lakes",
      chart: "",
      unit: "count",
      plotOptions: {
        series: {
          tooltip: {
            pointFormat: "{point.name}: <b>{point.y:,.0f}</b>",
          },
        },
      },
      series: {
        Count: {
          Bedrock: 6,
          "Ice dammed": 236,
          "Landslide dammed": 3,
          "Moraine dammed": 363,
          Supraglacial: 75,
          Unknown: 31,
          "Water pocket": 22,
        },
      },
    },
  ],
  14: [
    {
      type: "column",
      title: "No. of Glaciers in Afghanistan",
      chart: "",
      unit: "count",
      plotOptions: {
        series: {
          tooltip: {
            pointFormat: "{point.name}: <b>{point.y:,.2f}</b>",
          },
          showInLegend: false,
        },
      },
      series: {
        Count: {
          1990: 4014,
          2000: 3977,
          2010: 3946,
          2015: 3891,
        },
      },
    },
    {
      type: "column",
      title: "Area of Glaciers in Afghanistan (sq. km.)",
      chart: "",
      unit: "sq km",
      plotOptions: {
        series: {
          tooltip: {
            pointFormat: "{point.name}: <b>{point.y:,.2f} sq. km.</b>",
          },
        },
      },
      series: {
        Area: {
          1990: 2948.76,
          2000: 2842.89,
          2010: 2709.04,
          2015: 2542.62,
        },
      },
    },
    {
      type: "column",
      title: "Estimated Ice Reserve in Afghanistan (cu. Km.)",
      chart: "",
      unit: "cu. km.",
      plotOptions: {
        series: {
          tooltip: {
            pointFormat: "{point.name}: <b>{point.y:,.2f} cu. km.</b>",
          },
        },
      },
      series: {
        "Est. Ice Reserve": {
          1990: 181.236,
          2000: 174.224,
          2010: 164.656,
          2015: 155.147,
        },
      },
    },
  ],
  15: [
    {
      type: "column",
      title: "No. of Glaciers in Bhutan ",
      chart: "",
      unit: "count",
      plotOptions: {
        series: {
          tooltip: {
            pointFormat: "{point.name}: <b>{point.y:,.0f}</b>",
          },
          dataSorting: {
            enabled: false,
          },
          showInLegend: false,
        },
      },
      series: {
        Count: {
          1980: 772,
          1990: 836,
          2000: 878,
          2010: 886,
        },
      },
    },
    {
      type: "column",
      title: "Glacier Area in Bhutan (sq. Km.)",
      chart: "",
      unit: "sq km",
      plotOptions: {
        series: {
          tooltip: {
            pointFormat: "{point.name}: <b>{point.y:,.0f} sq km</b>",
          },
          dataSorting: {
            enabled: false,
          },
          showInLegend: false,
        },
      },
      series: {
        "sq km": {
          1980: 837.59,
          1990: 740.42,
          2000: 688.19,
          2010: 642.07,
        },
      },
    },
    {
      type: "column",
      title: "Est. Ice Reserve in Bhutan (cu. Km.)",
      chart: "",
      unit: "cu.km.",
      plotOptions: {
        series: {
          tooltip: {
            pointFormat: "{point.name}: <b>{point.y:,.2f} cu.km.</b>",
          },
          dataSorting: {
            enabled: false,
          },
          showInLegend: false,
        },
      },
      series: {
        "cu km": {
          1980: 62.685,
          1990: 53.759,
          2000: 48.565,
          2010: 45.031,
        },
      },
    },
  ],
  17: [
    {
      type: "column",
      title: "Forest Fire Count in Bhutan",
      chart: "",
      unit: "count",
      plotOptions: {
        series: {
          tooltip: {
            pointFormat: "{point.name}: <b>{point.y:,.0f} </b>",
          },
          dataSorting: {
            enabled: false,
          },
        },
      },
      series: {
        Count: {
          2024: 151,
          2023: 233,
          2022: 110,
          2021: 285,
          2020: 149,
          2019: 141,
          2018: 157,
          2017: 264,
          2016: 244,
          2015: 279,
          2014: 373,
          2013: 254,
          2012: 461,
          2011: 301,
          2010: 488,
          2009: 404,
          2008: 259,
          2007: 354,
          2006: 400,
          2005: 234,
          2004: 240,
          2003: 193,
          2002: 132,
          2001: 213,
        },
      },
    },
  ],
  18: [
    {
      type: "stacked_column",
      title: "Provincewise Hydropower Plants",
      titleAlign: "center",
      unit: "mw",
      categories: [
        "Bagmati",
        "Gandaki",
        "Karnali",
        "Koshi",
        "Lumbini",
        "Sudurpaschim",
      ],
      yAxis: {
        min: 0,
        title: {
          text: "megawatt",
        },
      },
      legend: {
        align: "center",
        borderColor: "#CCC",
        borderWidth: 1,
        shadow: false,
      },
      colorMap: {
        Operational: "#55FF00",
        "Under Construction": "#FFA900",
        Planned: "#00C5FF",
      },
      series: [
        {
          name: "Operational",
          data: [1199.974, 810.13, 8.55, 670.636, 184.924],
        },
        {
          name: "Planned",
          data: [466.61, 2327.944, 5132.79, 3120.11, 46.72, 118],
        },
        {
          name: "Under Construction",
          data: [2410.278, 3097.35, 1028.65, 3014.08, 49.96, 561.1],
        },
      ],
    },
    {
      type: "pie",
      title: "Status of Hydropower",
      chart: "",
      unit: "mw",
      plotOptions: {
        series: {
          tooltip: {
            pointFormat: "{point.name}: <b>{point.y:,.2f} mw</b>",
          },
        },
      },
      series: {
        megawatt: {
          Operational: 3049.584,
          Planned: 11212.174,
          "Under Construction": 10161.418,
        },
      },
    },
  ],
  19: [
    {
      type: "column",
      title: "Land Cover Distribution 2022",
      chart: "",
      unit: "ha",
      plotOptions: {
        series: {
          tooltip: {
            pointFormat: "{point.name}: <b>{point.y:,.2f} ha</b>",
          },

          showInLegend: false,
        },
      },

      series: {
        Area: {
          Forest: 6399341.397,
          "Other wooded land": 397916.174,
          Grassland: 2169462.338,
          Cropland: 3332566.24,
          "Bare soil": 1885.364503,
          "Bare rock": 772360.3137,
          "Built-up": 475876.6064,
          Snow: 577211.5387,
          Glacier: 450718.6728,
          Waterbody: 60237.27025,
          Riverbed: 114024.0851,
        },
      },
      colorMap: {
        Waterbody: "#081cfb",
        Forest: "#006f00",
        Riverbed: "#a6dcda",
        "Built-up": "#ff0000",
        Cropland: "#f6ee04",
        "Bare soil": "#dcd4e1",
        Grassland: "#91ef7a",
        Glacier: "#6DA3AF",
        Snow: "#00ffff",
        "Bare rock": "#E2D3E8",
        "Other wooded land": "#A0DA41",
      },
    },
  ],
  21: [
    {
      type: "column",
      title: "Landslides Occurence in Hindu Kush Himalaya",
      chart: "",
      unit: "count",
      plotOptions: {
        series: {
          tooltip: {
            pointFormat: "{point.name}: <b>{point.y:,.0f}</b>",
          },
          dataSorting: {
            enabled: false,
          },
          showInLegend: false,
          color: "#FA4B42",
        },
      },
      series: {
        Count: {
          2014: 1257,
          2015: 218,
          2016: 252,
          2017: 292,
          2018: 698,
          2019: 6,
          2020: 122,
          2021: 1,
          2023: 3,
          2024: 1,
          // "2004": 0,
          // "2005": 1,
          // "2006": 0,
          // "2007": 2,
          // "2008": 4,
          // "2009": 3,
          // "2010": 3,
          // "2011": 2,
          // "2012": 1,
          // "2013": 0,
          // "2014": 1,
          // "2015": 1,
          // "2016": 0,
          // "2017": 1
        },
      },
    },
    {
      type: "column",
      title: "Landslides Fatality in Hindu Kush Himalaya",
      chart: "",
      unit: "count",
      plotOptions: {
        series: {
          tooltip: {
            pointFormat: "{point.name}: <b>{point.y:,.0f}</b>",
          },
          dataSorting: {
            enabled: false,
          },
          showInLegend: false,
          color: "#FA4B42",
        },
      },
      series: {
        Count: {
          2014: 10460,
          2015: 2952,
          2016: 625,
          2017: 560,
          2018: 90,
          2019: 1,
          2020: 213,
          2021: 2,
          2023: 4,
          2024: 0,
          // "2004": 0,
          // "2005": 1,
          // "2006": 0,
          // "2007": 3,
          // "2008": 23,
          // "2009": 10,
          // "2010": 6,
          // "2011": 2,
          // "2012": 1,
          // "2013": 0,
          // "2014": 1,
          // "2015": 4,
          // "2016": 0,
          // "2017": 1
        },
      },
    },
  ],
  6: [
    {
      type: "column",
      title: "Land Cover Hindu Kush Himalaya in 2022",
      chart: "",
      unit: "ha",
      plotOptions: {
        series: {
          tooltip: {
            pointFormat: "{point.name}: <b>{point.y:,.2f} ha</b>",
          },
          showInLegend: false,
        },
      },
      series: {
        Area: {
          Waterbody: 60237.27,
          Glacier: 450718.67,
          Snow: 577211.53,
          Forest: 6399341.39,
          Riverbed: 114024.08,
          "Built-up": 475876.6,
          Cropland: 3332566.23,
          "Bare soil": 1885.36,
          "Bare rock": 772360.31,
          Grassland: 2169462.33,
          "Other wooded land": 397916.17,
        },
      },
      colorMap: {
        Waterbody: "#081cfb",
        Forest: "#006f00",
        Riverbed: "#a6dcda",
        "Built-up": "#ff0000",
        Cropland: "#f6ee04",
        "Bare soil": "#dcd4e1",
        Grassland: "#91ef7a",
        Glacier: "#6DA3AF",
        Snow: "#00ffff",
        "Bare rock": "#E2D3E8",
        "Other wooded land": "#A0DA41",
      },
    },
    // {
    //     "type": "pie",
    //     "title": "Land Cover Distribution (Pie Chart)",
    //     "unit": "%",
    //     "series": {
    //         "Distribution": {
    //             "Waterbody": 60237.27,
    //             "Glacier": 450718.67,
    //             "Snow": 577211.53,
    //             "Forest": 6399341.39,
    //             "Riverbed": 114024.08,
    //             "Built-up": 475876.60,
    //             "Cropland": 3332566.23,
    //             "Bare soil": 1885.36,
    //             "Bare rock": 772360.31,
    //             "Grassland": 2169462.33,
    //             "Other wooded land": 397916.17
    //         }
    //     }
    // }
  ],
  8: [
    {
      type: "column",
      title: "No. of Glaciers in the HKH ",
      chart: "",
      unit: "",
      plotOptions: {
        series: {
          tooltip: {
            pointFormat: "{point.name}: <b>{point.y:,.0f} </b>",
          },
          showInLegend: false,
        },
      },
      series: {
        Count: {
          Ganga: 7963,
          Brahmaputra: 10274,
          Irrawaddy: 133,
          Amudarya: 3277,
          Indus: 17925,
        },
      },
    },

    {
      type: "column",
      title: "Area of Glaciers in the HKH (sq. Km.)",
      chart: "",
      unit: "sq km",
      plotOptions: {
        series: {
          tooltip: {
            pointFormat: "{point.name}: <b>{point.y:,.0f} sq km</b>",
          },
          showInLegend: false,
        },
      },
      series: {
        Count: {
          Ganga: 9017,
          Brahmaputra: 12898,
          Irrawaddy: 35,
          Amudarya: 2567,
          Indus: 20789,
          // "Glacier Area Total": 45306
        },
      },
    },

    // {
    //     "type": "column",
    //     "title": "Glacier Area/Ice Reserve in Bhutan",
    //     "chart": "",
    //     "unit": "cu km",
    //     "plotOptions": {
    //         "series": {
    //             "tooltip": {
    //                 "pointFormat": "{point.name}: <b>{point.y:,.2f} cu km</b>"
    //             },
    //             // Add this to override default sorting
    //             "dataSorting": {
    //                 "enabled": false
    //             }
    //         }
    //     },
    //     "series": {
    //         "IceReserve": {
    //             "1980": 62.685,
    //             "1990": 53.739,
    //             "2000": 48.565,
    //             "2010": 45.031
    //         },
    //         "Area": {
    //             "1980": 837.59,
    //             "1990": 740.72,
    //             "2000": 688.19,
    //             "2010": 642.07
    //         },
    //         "Count": {
    //             "1980": 772,
    //             "1990": 836,
    //             "2000": 878,
    //             "2010": 886
    //         }
    //     },
    //     "colorMap": {
    //         "IceReserve": "#228B22",
    //         "Area": "#808080",
    //         "Count": "#8B0000"
    //     }
    // }
  ],
  22: [
    {
      type: "stacked_column",
      title: "Countrywise Hydropower Plants",
      titleAlign: "center",
      unit: "mw",
      categories: [
        "Afghanistan",
        "Bangladesh",
        "Bhutan",
        "China",
        "India",
        "Myanmar",
        "Nepal",
        "Pakistan",
      ],
      yAxis: {
        min: 0,
        title: {
          text: "megawatt",
        },
      },
      legend: {
        align: "center",
        borderColor: "#CCC",
        borderWidth: 1,
        shadow: false,
      },
      colorMap: {
        Operational: "#55FF00",
        "Under Construction": "#FFA900",
        "Planned or Proposed": "#00C5FF",
      },
      series: [
        {
          name: "Operational",
          data: [199.55, 230, 2302, 118382, 22335, 939, 3241.584, 7030],
        },
        {
          name: "Planned or Proposed",
          data: [407, 0, 570, 19448, 22444, 7138, 11255.534, 4827],
        },
        {
          name: "Under Construction",
          data: [0, 0, 7363, 142552, 37679, 9993, 10054.733, 32752.4],
        },
      ],
    },
  ],
  23: [
    {
      type: "column",
      title: "Forest Fire Counts in HKH",
      chart: "",
      unit: "",
      plotOptions: {
        series: {
          tooltip: {
            pointFormat: "{point.name}: <b>{point.y:,.0f}</b>",
          },
          dataSorting: {
            enabled: false,
          },
          color: "#FA4B42",
          showInLegend: false,
        },
      },
      series: {
        Count: {
          2001: 16827,
          2002: 10089,
          2003: 56160,
          2004: 76591,
          2005: 57380,
          2006: 70194,
          2007: 85170,
          2008: 55615,
          2009: 91987,
          2010: 88180,
          2011: 49228,
          2012: 79046,
          2013: 64359,
          2014: 65294,
          2015: 48877,
          2016: 51092,
          2017: 39367,
          2018: 42082,
          2019: 51737,
          2020: 54396,
          2021: 65288,
          2022: 33760,
          2023: 56971,
        },
      },
    },
    {
      type: "pie",
      title: "Forest Fire by Country within HKH region in 2023 ",
      chart: "",
      unit: "",
      plotOptions: {
        series: {
          tooltip: {
            pointFormat: "{point.name}: <b>{point.y:,.0f}</b>",
          },
        },
      },
      series: {
        count: {
          Afghanistan: 38,
          Bangladesh: 2329,
          Bhutan: 244,
          China: 2813,
          India: 12697,
          Myanmar: 35184,
          Nepal: 3350,
          Pakistan: 316,
        },
      },
    },
  ],
};
